import { settingPageRoutes } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const page_template = (queryParams) => axiosAuthInstance.get(settingPageRoutes.page_template, { params: queryParams });
export const faq_page = (queryParams) => axiosAuthInstance.get(settingPageRoutes.faq_page, { params: queryParams });
